// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceProductPrice {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.stripePriceId = model.stripePriceId;
        this.stripeProductId = model.stripeProductId;
        this.stripeProductDescription = model.stripeProductDescription;
        this.stripeProductFeatures = model.stripeProductFeatures;
        this.stripeProductAdditionalFeatures = model.stripeProductAdditionalFeatures;
        this.active = model.active;
        this.amount = model.amount;
        this.interval = model.interval;
        this.isPricePerCreator = model.isPricePerCreator;
        this.legacyVersion = model.legacyVersion || null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toRemote() {
        return {
            stripePriceId: this.stripePriceId,
            stripeProductId: this.stripeProductId,
            stripeProductDescription: this.stripeProductDescription,
            stripeProductFeatures: this.stripeProductFeatures,
            stripeProductAdditionalFeatures: this.stripeProductAdditionalFeatures,
            active: this.active,
            amount: this.amount,
            interval: this.interval,
            isPricePerCreator: this.isPricePerCreator,
            // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
            legacyVersion: this.legacyVersion,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceProductPrice(model);
    }
}
